module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_hokkaido-03125b8137dea93b04efeb34f18fe804.jpg";